import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, FormGroup, Label, Input, Button, Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import { Eye, EyeOff } from "react-feather";
import classNames from "classnames";

import Logo from "~/assets/images/login/login-logo.svg";

import FacebookLogin    from "./ThirdPartyLogin/Facebook/Button";
import GoogleLogin      from "./ThirdPartyLogin/Google/Button";
import BlockedUserModal from "./BlockedUserModal";

import ValidationGroup, { ValidatorMark } from "~/components/validation";

import getRecaptcha from "../_services/recaptcha";
import security     from "~/services/security";


const Login = (props)=> {

  const defaultCredentials = {
    email    : "",
    password : ""
  };

  const [credentials    , setCredentials]    = useState(defaultCredentials);
  const [loading        , setLoading]        = useState(false);
  const [togglePassword , setTogglePassword] = useState(false);
  const [isModalOpen    , setModalOpen]      = useState(false);
  const [banMessage     , setBanMessage]     = useState("");
  const [errors         , setErrors]         = useState({});

  const validation = ValidationGroup("Login");

  useEffect(()=> {
    if(props.location?.message?.type !== 'error') return;
    setBanMessage(props.location?.message?.banMessage);
    setModalOpen(true);
  }, [props]);

  const changeProp = (prop, value)=> setCredentials({...credentials, [prop]: value});

  const hasErrors = ()=> {

    const errorList = {
      ...validation("email"    , credentials.email),
      ...validation("password" , credentials.password)
    };

    setErrors(errorList);

    return Boolean(Object.values(errorList).length);
  }

  const authenticateUser = async (e)=> {

    e.preventDefault();
    if(hasErrors()) return;
    setLoading(true);

    const redirect = props.location.state?.from || {pathname: "/dashboard"};
    const recaptcha = await getRecaptcha();

    return security.loginEmail({...credentials, recaptcha})
      .then(()=> props.history.push({  ...redirect }))
      .catch((e)=> {
        setErrors(e);
        if(e.status === 401 && 'banMessage' in e.data.error) {
          setBanMessage(e.data.error.banMessage);
          setModalOpen(true);
        }
      }).finally(()=> setLoading(false));
  };

  return (
    <Fragment>

      <BlockedUserModal
        isModalOpen={isModalOpen}
        setModalOpen={setModalOpen}
        banMessage={banMessage}
      />

      <div className="login-card push-bg">

        <div>
          <Link to={"/login"} className="logo"> <img src={Logo}/> </Link>

          <div className="login-main">
            <Form className="theme-form text-center" onSubmit={authenticateUser}>

              <h3 className='greeting'> Hi there! login to continue </h3>

              <FormGroup>
                <Label className="col-form-label">Email Address</Label>
                <Input type="email"
                  placeholder="Email"
                  value={credentials.email}
                  required={true}
                  onChange={(e)=> changeProp("email", e.target.value)}
                  className={classNames({ valid: !validation("email", credentials.email), 'is-invalid': errors.email || errors.generalError})}
                />

                <ValidatorMark val={credentials.email} name="email" validation={validation} errors={errors} textOnly={errors.generalError} />
                <ValidatorMark name="generalError" validation={validation} errors={errors}  />
              </FormGroup>

              <FormGroup>
                <Label className="col-form-label">Password</Label>
                <Input type={togglePassword ? "text" : "password"}
                  placeholder="Password"
                  value={credentials.password}
                  required={true}
                  onChange={(e) => changeProp("password", e.target.value)}
                  className={classNames({'is-invalid': errors.password})}
                />

                <ValidatorMark val={credentials.password} name="password" validation={validation} errors={errors} textOnly={true} />

                <div className="validation-mark" onClick={()=> setTogglePassword(!togglePassword) }>
                  { togglePassword ? <Eye color="var(--theme-deafult)"/> : <EyeOff color="var(--theme-deafult)" /> }
                </div>

                <div className="forgot-password-link">
                  <Link to={"/reset-password-request"}> Forgot Password? </Link>
                </div>
              </FormGroup>

              <FormGroup className="m-t-30 m-b-30">
                <Button color="login" className="btn-block" disabled={loading} type="submit">
                  { loading ? <Spinner size="sm" /> : "Login" }
                </Button>
              </FormGroup>

              <h6 className="or">or sign in with</h6>

              <Row className="m-b-30">
                <Col xs="6" className="p-r-10"> <FacebookLogin color="fb" /> </Col>
                <Col xs="6" className="p-l-10"> <GoogleLogin color="google" /> </Col>
              </Row>

              <p> Dont have an Account? <Link className="ml-2" to={"/register"}> <strong> Create one </strong></Link> </p>
            </Form>

          </div>

        </div>
      </div>
    </Fragment>
  );
};

export default Login;
